import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const SnagPinPreviewSkeleton: React.FC = () => {
  return <Skeleton className="h-40 w-full rounded-md" />
}

export default SnagPinPreviewSkeleton
